export const API_BASE_URL = process.env.REACT_APP_BACK_END_URL;
// export const API_BASE_URL = "https://1263backend.ashamlolie.com/";
// export const API_BASE_URL = "https://dev-backend-tau.vercel.app/";
